import { cssAnchorProps } from "@circle-react/helpers/cssAnchorHelpers";
import { useBoolean } from "@circle-react/hooks/utils/useBoolean";

import { t } from "@/i18n-js/instance";

import { CollapsibleSection } from "../CollapsibleSection";
import { LinksList } from "./LinksList";
import { useLinks } from "./useLinks";

export const LinksSection = () => {
  const [isCollapsed, toggleCollapsed] = useBoolean(false);
  const { canSeeLinks, isAdmin, onSort, orderedList } = useLinks();

  if (!canSeeLinks) {
    return null;
  }

  return (
    <CollapsibleSection
      id="links-section"
      {...cssAnchorProps({ anchor: "app-sidebar-links" })}
    >
      <CollapsibleSection.Header
        isCollapsed={isCollapsed}
        title={t("links")}
        onCollapseToggle={toggleCollapsed}
      />
      <CollapsibleSection.Content isCollapsed={isCollapsed}>
        <LinksList isAdmin={isAdmin} links={orderedList} onSort={onSort} />
      </CollapsibleSection.Content>
    </CollapsibleSection>
  );
};
